import { AfterViewInit, Component, OnInit } from '@angular/core';
import { BaseComponent, DataTableRequest, FormatService, LanguageService, SearchData, ValidationHandlerService } from 'lib/Vestra.shared';
import { DatePipe } from '@angular/common';
import { BsModalService } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { firstValueFrom } from 'rxjs';
import { CoreService } from 'src/app/services/api-services';
import { ADTSettings } from 'angular-datatables/src/models/settings';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
    selector: 'app-business-log-list',
    templateUrl: './business-log-list.component.html',
    styleUrls: ['./business-log-list.component.scss'],
})
export class BusinessLogListComponent extends BaseComponent implements OnInit, AfterViewInit {
    constructor(private translateService: TranslateService, protected override modalService: BsModalService, protected override spinnerService: NgxSpinnerService, private coreService: CoreService, protected override validationHandlerService: ValidationHandlerService, protected override languageService: LanguageService, private formatService: FormatService, public datePipeInstance: DatePipe, private router: Router) {
        super(spinnerService, modalService, validationHandlerService, translateService, languageService);
    }

    public ngOnInit() {
        this.dataTableOnInit();
    }

    public ngAfterViewInit() {
        this.dataTableAfterViewInit();
    }

    public ngOnDestroy() {
        this.dataTableOnDestroy();
    }

    public override getDtOptions() {
        this.languageUrl = this.languageService.getTranslationUrl();

        const res: ADTSettings = {
            serverSide: true,
            processing: false,
            pageLength: 20,
            lengthChange: false,
            responsive: {
                details: {
                    type: 'column',
                    target: -1,
                },
            },
            searching: false,
            destroy: true,
            language: {
                url: this.languageUrl,
            },
            ajax: (dataTablesParams: any, callback: any) => {
                const searchData: SearchData = {
                    value: this.searchValue,
                };

                for (let order of dataTablesParams.order) {
                    order.name = dataTablesParams.columns[order.column]?.data;
                }

                const model: DataTableRequest = {
                    draw: dataTablesParams.draw,
                    start: dataTablesParams.start,
                    length: dataTablesParams.length,
                    order: dataTablesParams.order,
                    search: searchData,
                    columns: this.transformToColumnData(this.dtOptions.columns),
                };

                this.datatableRequest = model;

                this.handleSpinner(firstValueFrom(this.coreService.getBusinessLogListDataSource(model)))
                    .then(res => {
                        callback(this.getTableData(res));
                        return Promise.resolve(res);
                    })
                    .catch((err: HttpErrorResponse) => {
                        this.validationHandlerService.handleServerError(err);
                        callback(this.getEmptyTableData());
                    });
            },
            columns: [
                {
                    data: 'created',
                    title: 'business_log.created',
                    responsivePriority: 1,
                    searchable: true,
                    orderable: true,
                    render: data => {
                        if (!data) {
                            return '';
                        }

                        const date = new Date(data);
                        if (!isNaN(date.getTime())) {
                            return this.formatService.formatDateTime(date);
                        }
                        return data;
                    },
                },
                {
                    data: 'userName',
                    title: 'business_log.user_name',
                    searchable: false,
                    orderable: true,
                },
                {
                    data: 'userDisplayName',
                    title: 'business_log.user_display_name',
                    searchable: false,
                    orderable: true,
                },
                {
                    data: 'logMessage',
                    title: 'business_log.log_message',
                    searchable: false,
                    orderable: true,
                },
                {
                    data: 'categoryType',
                    title: 'business_log.category_type',
                    searchable: false,
                    orderable: true,
                },
                {
                    data: 'logType',
                    title: 'business_log.log_type',
                    searchable: false,
                    orderable: true,
                },
                {
                    data: 'entityId',
                    title: 'business_log.entity_id',
                    searchable: false,
                    orderable: true,
                },
                {
                    data: 'traceId',
                    title: 'business_log.trace_id',
                    searchable: false,
                    orderable: true,
                },
                {
                    data: '',
                    orderable: false,
                    responsivePriority: 1,
                    render: function (data) {
                        return '';
                    },
                },
            ],
            columnDefs: [
                {
                    targets: '_all',
                    visible: true,
                },
                {
                    className: 'details-icon dtr-control',
                    orderable: false,
                    target: -1,
                },
            ],
        };

        return res;
    }

    public onSearch(event: string): void {
        this.searchValue = event;
        this.refreshDataTable();
    }
}
